<template>
  <Content class="col-span-full" :title="$route.name" :showAdd="false">
    <div v-loading="loading" class="grid grid-cols-1 p-4 gap-4">
      <Field :title="$t('COMPANY_NAME')"
        >{{ $i18n.locale == "fa" ? tableData.fa_title : tableData.en_title }}
      </Field>
      <Field :title="$t('PHONE_NUMBER')">
        <a
          class="text-blue-500 hover:text-blue-700"
          :href="'tel:+98' + tableData.phone_number"
        >
          {{ tableData.phone_number }}
        </a>
      </Field>

      <Subtitle
        :title="$t('REPRESENTATIVE_INFO')"
        class="col-span-full mt-6 mb-8"
      />
      <Field :title="$t('FULL_NAME')"
        >{{
          tableData.representative.first_name +
          " " +
          tableData.representative.last_name
        }}
      </Field>
      <Field :title="$t('PHONE_NUMBER')">
        <a
          class="text-blue-500 hover:text-blue-700"
          :href="'tel:+98' + tableData.representative.mobile"
        >
          {{
            tableData.representative.mobile != ""
              ? "0" + tableData.representative.mobile
              : ""
          }}
        </a>
      </Field>
    </div>
  </Content>
</template>

<script>
import { companyprofile } from "@/api/profile";
import Field from "@/components/elements/field";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: true,
      tableData: {
        representative: {
          mobile: "",
          first_name: "",
          last_name: "",
        },
        fa_title: "",
        en_title: "",
        phone_number: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userId"]),
  },

  mounted() {
    companyprofile.api(this.userId).then((res) => {
      if (res) {
        this.tableData = res;
        this.loading = false;
      }
    });
  },
  components: {
    Field,
  },
};
</script>
